import FaseGrade from "../../../../../components/categories/siakad/lms/data_matpel/subpage/fase/config-class/Home";
export default function Home() {
  
  return (
    <FaseGrade />
  );
}
